import { render, staticRenderFns } from "./scholarcyUpload.vue?vue&type=template&id=841532da&scoped=true"
import script from "./scholarcyUpload.vue?vue&type=script&lang=js"
export * from "./scholarcyUpload.vue?vue&type=script&lang=js"
import style0 from "./scholarcyUpload.vue?vue&type=style&index=0&id=841532da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841532da",
  null
  
)

export default component.exports